<template>
<div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link>
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view></router-view>
    <WhatsAppChatModal />
  </div>
</template>
<script>
import WhatsAppChatModal from './components/WhatsAppChatModal.vue';

export default {
  name: 'App',
  components: {
    WhatsAppChatModal,
  },
  //  mounted() {
  //   // Listen for all modal hidden events
  //   document.addEventListener('hidden.bs.modal', () => {
  //     document.body.classList.remove('modal-open');
  //   });
  // },
  // watch: {
  //   $route() {
  //     // Remove Bootstrap modal-open class from body
  //     document.body.classList.remove('modal-open');
  //     // Remove all modal backdrops
  //     const backdrops = document.querySelectorAll('.modal-backdrop');
  //     backdrops.forEach(b => b.parentNode && b.parentNode.removeChild(b));
  //     // Hide any open modals
  //     const modals = document.querySelectorAll('.modal.show');
  //     modals.forEach(m => {
  //       m.classList.remove('show');
  //       m.style.display = 'none';
  //     });
  //   }
  // }
  mounted() {
  // Listen for all modal hidden events
  document.addEventListener('hidden.bs.modal', () => {
    // Wait a tick to ensure Bootstrap finished its logic
    setTimeout(() => {
      // If no modals are open, clean up body
      if (!document.querySelector('.modal.show')) {
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.overflowY = '';
        document.body.style.paddingRight = '';
      }
    }, 50);
  });
},
watch: {
  $route() {
    // Remove modal-open and backdrop
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.overflowY = '';
    document.body.style.paddingRight = '';

    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach(b => b.remove());

    const modals = document.querySelectorAll('.modal.show');
    modals.forEach(m => {
      m.classList.remove('show');
      m.style.display = 'none';
    });
  }
}
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
